import React, {Component} from 'react';
import OrgUsersCard from './orgUsersCard';
import OrgUserFormContainer from './orgUserFormContainer';
import REST from 'go/requests/rest';
import _ from 'lodash';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
class OrgUsersCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      addModalVisible: false,
      removeModalVisible: false,
      action: '',
      userData: [],
      entities: [],
      analyticsEntities: [],
      mapping: [],
      analyticsMapping: [],
      numEntityRoles: {},
    };
  }

  async componentDidMount() {
    try {
      let res = await Promise.all([
        this.fetchOrgProfileData(this.props.token),
        this.fetchRoleMapping(this.props.token),
        this.fetchEntities(this.props.token),
        this.fetchAnalyticsRoleMapping(this.props.token),
        this.fetchAnalyticsEntities(this.props.token),
      ]);
      const payload = await res;
      let userData = await forceJsonResponse(payload[0], MONO);
      let mapping = await forceJsonResponse(payload[1], MONO);
      let entities = await forceJsonResponse(payload[2], FLUX);
      let analyticsMapping = await forceJsonResponse(payload[3], MONO);
      let analyticsEntities = await forceJsonResponse(payload[4], FLUX);

      this.setState(
        {
          userData: userData,
          mapping: mapping,
          entities: entities,
          analyticsMapping: analyticsMapping,
          analyticsEntities: analyticsEntities,
          loading: false,
          selectedUser: {
            userId: '',
            role: {
              description: '',
            },
          },
        },
        () => {
          this.getNumEntityRoles(this.state.userData, this.state.entities);
        }
      );
    } catch (e) {
      console.log(e);
    }
  }

  fetchRoleMapping = async (token) => {
    return REST.user.getRoles(this.props.token);
  };

  fetchAnalyticsRoleMapping = async (token) => {
    return REST.user.getAnalyticsRoles(this.props.token);
  };

  fetchOrgProfileData = async (token) => {
    return REST.user.getOrgProfileData(token);
  };

  fetchEntities = async (token) => {
    return REST.user.getManagedEntities(this.props.token);
  };

  fetchAnalyticsEntities = async (token) => {
    return REST.user.getManagedAnalyticsRoles(this.props.token);
  };

  removeSelectedRole = async (userId, entityId, roleId, entityTypeId) => {
    let body = {
      userId: userId,
      entityId: entityId,
      roleId: roleId,
      entityTypeId: entityTypeId,
    };
    return REST.user.removeRole(this.props.token, body);
  };

  openRemoveModal = (user) => {
    this.setState({
      removeModalVisible: !this.state.removeModalVisible,
      selectedUser: user,
    });
  };

  toggleModal(action) {
    if (action === 'add') {
      this.setState({
        addModalVisible: !this.state.addModalVisible,
        action: action,
      });
    } else if (action === 'remove') {
      this.setState({
        removeModalVisible: !this.state.removeModalVisible,
        action: action,
      });
    } else if (action === 'addAnalytics') {
      this.setState({
        // addAnalyticsModalVisible: !this.state.addAnalyticsModalVisible
        addModalVisible: !this.state.addModalVisible,
        action: action,
      });
    }
  }

  reloadUserList = async () => {
    try {
      this.setState({loading: true});
      const res = await this.fetchOrgProfileData(this.props.token);
      const json = await forceJsonResponse(res, MONO);
      this.setState(
        {
          userData: json,
          loading: false,
          selectedUser: {
            userId: '',
            role: {
              description: '',
            },
          },
        },
        () => {
          this.getNumEntityRoles(this.state.userData, this.state.entities);
        }
      );
    } catch (e) {
      this.setState({
        loading: false,
      });
      console.log(e);
    }
  };

  getNumEntityRoles = (userData, entities) => {
    let entityRoles = {};
    _.forEach(entities, (entity) => {
      if (!_.has(entityRoles, entity.entityId)) {
        entityRoles[entity.entityId] = {};
      }
    });
    _.forEach(userData, (user) => {
      if (user.entity && user.role) {
        let userEntityId = user.entity.entityId;
        let userRole = user.role.roleId;
        if (_.has(entityRoles, userEntityId)) {
          if (!_.has(entityRoles[userEntityId], userRole)) {
            entityRoles[userEntityId][userRole] = 1;
          } else {
            entityRoles[userEntityId][userRole] += 1;
          }
        }
      }
    });

    this.setState({
      numEntityRoles: entityRoles,
    });
  };

  render() {
    return (
      <React.Fragment>
        <OrgUsersCard
          userData={this.state.userData}
          entities={this.state.entities}
          loading={this.state.loading}
          toggleModal={this.toggleModal.bind(this)}
          removeModalVisible={this.state.removeModalVisible}
          selectedUser={this.state.selectedUser}
          removeSelectedRole={this.removeSelectedRole}
          reloadUserList={this.reloadUserList.bind(this)}
          openRemoveModal={this.openRemoveModal.bind(this)}
          userId={this.props.userId}
          numEntityRoles={this.state.numEntityRoles}
        />
        <OrgUserFormContainer
          users={this.state.userData}
          entities={
            this.state.action === 'addAnalytics'
              ? this.state.analyticsEntities
              : this.state.entities
          }
          mapping={
            this.state.action === 'addAnalytics'
              ? this.state.analyticsMapping
              : this.state.mapping
          }
          editModalVisible={this.state.editModalVisible}
          addModalVisible={this.state.addModalVisible}
          action={this.state.action}
          toggleModal={this.toggleModal.bind(this)}
          reloadUserList={this.reloadUserList.bind(this)}
          token={this.props.token}
          parentOrgId={this.props.parentOrgId}
          isManuallyAdded={this.props.isManuallyAdded}
        />
      </React.Fragment>
    );
  }
}

export default OrgUsersCardContainer;
